import axios from '@/api/axios'
import axios_clear from 'axios'
import log_access from "@/api/log_access"

export default {
    login(login:string, password:string, isClient:boolean = true) {
        let route = isClient ? 'login_client' : 'login_admin';
        return new Promise(function(resolve, reject){
            axios_clear.post(`${process.env.VUE_APP_API_HOST}/api/${route}`, { login, password })
            .then((response:any) => {
                localStorage.setItem('auth.token',response.data.access_token);
                localStorage.setItem('auth.expires_in',response.data.expires_in);
                localStorage.setItem('auth.user_id',response.data.user.id);
                localStorage.setItem('auth.user_role',response.data.role);
                localStorage.setItem('auth.user_name',response.data.user.name);
                localStorage.setItem('auth.client_name',response.data.client);

                resolve(response);
            })
            .catch(error => {
                reject(error);
              });
        })
    },
    loginHash(hash:string) {
        return new Promise(function(resolve, reject){
            axios_clear.post(`${process.env.VUE_APP_API_HOST}/api/login_hash`, { hash })
            .then((response:any) => {
                localStorage.setItem('auth.token',response.data.access_token);
                localStorage.setItem('auth.expires_in',response.data.expires_in);
                localStorage.setItem('auth.user_id',response.data.user.id);
                localStorage.setItem('auth.user_role',response.data.role);
                localStorage.setItem('auth.user_name',response.data.user.name);
                localStorage.setItem('auth.client_name',response.data.client);

                resolve(response);
            })
            .catch(error => {
                reject(error);
              });
        })
    },
    logout(){
        log_access.close();
        return new Promise(function(resolve, reject){
            axios.delete(`${process.env.VUE_APP_API_HOST}/api/logout`)
            .then( response => {
                localStorage.setItem('auth.token', '');
                localStorage.setItem('auth.expires_in', '');
                localStorage.setItem('auth.user_id', '');
                localStorage.setItem('auth.user_role', '');
                localStorage.setItem('auth.user_name', '');
                
                resolve(response);
            })
            .catch( error => {
                reject(error);
            })
        })
    },
    passwordRecovery(email:String){
        return new Promise(function(resolve, reject){
            axios_clear.post(`${process.env.VUE_APP_API_HOST}/api/password_recovery`, { email })
            .then((response:any) => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
              });
        })
    }
}